import { LoadingButton } from '@mui/lab'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material'
import { GreenText } from 'components'
import { DateField } from 'components/fields'
import { sendBackToCanadaValidationSchema, VehicleConformitySendBackToCanadaDto } from 'dtos/vehicles/conformity'
import { Form, Formik } from 'formik'

interface SendBackToCanadaDialogProps {
  initialValues?: VehicleConformitySendBackToCanadaDto
  isLoading: boolean
  onClose: () => void
  onSave: (values: VehicleConformitySendBackToCanadaDto) => void
  open: boolean
}

export default function SendBackToCanadaDialog({ initialValues, isLoading, onClose, onSave, open }: SendBackToCanadaDialogProps) {
  return (
    <Dialog open={open}>
      <Formik
        enableReinitialize
        initialValues={initialValues ?? {}}
        onSubmit={values => {
          onSave(values)
        }}
        validateOnBlur={false}
        validateOnChange={true}
        validationSchema={sendBackToCanadaValidationSchema}
      >
        {({ errors, handleBlur, handleChange, setFieldValue, touched, values }) => {
          return (
            <Form>
              <DialogContent>
                <Grid container spacing={2} alignItems='center'>
                  <DialogTitle>Send Back To Canada</DialogTitle>

                  <Grid item xs={12}>
                    <DateField
                      disabled={isLoading}
                      error={Boolean(errors.sentBackToCanadaDate)}
                      helperText={errors.sentBackToCanadaDate}
                      label='Sent Back To Canada'
                      onChange={value => setFieldValue('sentBackToCanadaDate', value)}
                      value={values.sentBackToCanadaDate}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      disabled={isLoading}
                      error={Boolean(errors.sentBackToCanadaRecordNumber)}
                      fullWidth
                      helperText={errors.sentBackToCanadaRecordNumber}
                      label='Record #'
                      name='sentBackToCanadaRecordNumber'
                      onBlur={handleBlur}
                      onChange={handleChange}
                      type='text'
                      value={values.sentBackToCanadaRecordNumber ?? ''}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <GreenText variant='outlined'>
                      {`**Sent Back To Canada Date Field:**

A date-only field for entering the Sent Back To Canada date.

This field is required.

**Record # Field:**

A free-text field for entering the Record Number.

This field is required.

**CANCEL Button:**

Clicking the CANCEL button will close the dialog and not save any changes

**SAVE Button:** 

Clicking the SAVE button will save any changes.`}
                    </GreenText>
                  </Grid>
                </Grid>
              </DialogContent>

              <DialogActions>
                <Button color='inherit' disabled={isLoading} onClick={onClose} variant='text'>
                  CANCEL
                </Button>

                <LoadingButton loading={isLoading} type='submit' onClick={() => console.log(errors)} variant='contained'>
                  SAVE
                </LoadingButton>
              </DialogActions>
            </Form>
          )
        }}
      </Formik>
    </Dialog>
  )
}
